/* eslint-disable prefer-destructuring */
// envs
export const API_URL = process.env.BFF_URL;
export const RISK_API_URL = process.env.RISK_MANAGER_BFF_URL;
export const CONTACT_API_URL = process.env.CONTACT_API_URL;
export const FRETEBRAS_LOGOUT_URL = process.env.FRETEBRAS_LOGOUT_URL;

// end-point URLs
export const ADDRESS_BY_ZIP_CODE_URL = 'address';
export const CITIES_BY_NAME_URL = 'federation/cities/suggest';
export const FEATURE_TOGGLE_URL = 'company/features-access';
export const RISK_ERRORS_LIST_URL = 'api/v1/risk-management/:uuid/errors';
export const SEARCH_URL = 'risk-management';
export const TRUCKER_DATA_BY_DOCUMENT_URL = 'risk-management/truck/owner/{document}';
export const TRUCKER_PROFILE_URL = 'truckers/profile';
export const TRUCK_TYPES_URL = 'risk-management/truck-types-subtypes';
export const VEHICLE_BY_PLATE_URL = 'api/v2/crlvs';
export const RNTRC_AUTOCOMPLETE_URL = 'api/v1/rntrcs/auto-complete';

export const RNTRC_BY_OWNER_URL = 'api/v1/rntrcs';
export const RNTRC_DATA_WITH_UUID = `${RNTRC_BY_OWNER_URL}/auto-complete`;
export const USER_DATA_URL = 'user/me';
export const FREIGHT_URL = 'freights/{freightId}';
export const SEND_WHATSAPP_URL = 'motorista_nao_encontrado_gr/';
export const REFUNDABLE_FARE_URL = 'api/v1/freights/:freightId/truckers/:truckerId/refundable-fares';

// redirects
export const RISK_LIST = '/gestao-de-risco';
export const RISK_REGISTER_URL = '/gestao-de-risco/registrar';
export const RISK_LIST_SUCCESS = `${RISK_LIST}?listagem`;
export const RISK_ONBOARDING_URL = `${RISK_LIST}/onboarding`;
export const FREIGHT_LISTING = '/meus-fretes';

// other
export const AUTHORIZATION_KEY = '_TOKEN_BFF';
export const CONTACT_NUMBER = '(11) 4118-1843';
export const TRUCKER_SUPPORT_NUMBER = '(11) 4118-1845';
export const FEATURE_NAME = 'risk_management';
export const CITY_STATE_REGEXP = /^(.+)\s-\s(\w{2,3})$/i;

// custom error message
export const NOT_FOUND_CUSTOM = 'Não foi encontrado nenhum dado. Favor realizar o preenchimento manualmente.';
export const PORTAL_NAME = 'portal-risk-management-register-resend';
